import PropTypes from 'prop-types';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { formatPrice, getCmsFileUrl } from '../../library/utilities';
import ProductImageWithNote from './product-image-with-note';
import styles from './quotation-item-preview.module.scss';

const ItemPreview = ({ item }) => {
    const { t } = useTranslation()

    return (
        <div className={`box box--light-gray ${styles.wrapper}`}>
            <div className="box">
                <h3>{t("Item Name")}</h3>
                <h2>{item.product.name}</h2>
            </div>
            <div className={styles.item}>
                <div className={styles.left}>
                    <div className="box box--dark-gray">
                        <ProductImageWithNote
                            className={styles.image}
                            src={item.product.main_photos?.[0] && getCmsFileUrl(item.product.main_photos[0])}
                        />
                    </div>
                </div>
                <div className={styles.right}>
                    <div className="box box--dark-gray">
                        <h2>{t('Specifications')}</h2>
                        <div className={styles.specifications}>
                            {item.specification.map(({ name, value }) => (
                                <React.Fragment key={name}>
                                    <div className={styles.name}>{name}</div>
                                    <div className={styles.value}>{value}</div>
                                </React.Fragment>
                            ))}
                        </div>
                        <hr />
                        <div className={styles.quantities}>
                            <div className={`${styles.quantityHeading} ${styles.quantityRow}`}>
                                <div>{t('Quantity')}</div>
                                <div>{t('Sales Price/Piece')}</div>
                                <div>{t('Total Amount')}</div>
                            </div>
                            <div className={styles.quantityRow} key={item.id}>
                                <div>{item.quantity}</div>
                                <div>{formatPrice(item.approved_unit_price, item.currency.code)}</div>
                                <div>{formatPrice((parseFloat(item.approved_unit_price) * parseInt(item.quantity)), item.currency.code)}</div>
                            </div >
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}
ItemPreview.propTypes = {
    item: PropTypes.object
}

export default ItemPreview
